(function () {
  'use strict';

  var NAV_DELAY = 400;
  var loader = document.querySelector('[data-big-page-loader]');
  var navigationTimer = null;

  if (!loader) return;

  function isDesignMode() {
    return Boolean(window.Shopify && window.Shopify.designMode);
  }

  function hasModifiedClick(event) {
    return event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;
  }

  function isSpecialProtocol(href) {
    var normalized = href.trim().toLowerCase();
    return normalized.indexOf('mailto:') === 0 ||
      normalized.indexOf('tel:') === 0 ||
      normalized.indexOf('sms:') === 0 ||
      normalized.indexOf('whatsapp:') === 0 ||
      normalized.indexOf('https://wa.me/') === 0 ||
      normalized.indexOf('http://wa.me/') === 0 ||
      normalized.indexOf('https://api.whatsapp.com/') === 0 ||
      normalized.indexOf('http://api.whatsapp.com/') === 0;
  }

  function isIgnoredElement(link) {
    return Boolean(link.closest([
      'form',
      '[data-open-overlay]',
      '[data-close-overlay]',
      '[data-open-quick-search]',
      '[data-quick-search-form]',
      '[data-bigcars-filter-form]',
      '[data-remove-filter]',
      '[data-filter-reset-button]',
      '[data-close-filters]',
      '[data-loader-ignore]',
      '.no-transition',
      '.bigcars-header__mobile-toggle',
      '.bigcars-header__mobile-menu',
      '.bigcars-modal-overlay',
      '.quick-cart',
      '.filters',
      '.filters-active',
      '.panel',
      '.modal',
      '.modal-full-content'
    ].join(',')));
  }

  function shouldHandleLink(link, event) {
    if (!link || hasModifiedClick(event) || isDesignMode()) return false;

    var href = link.getAttribute('href');
    if (!href || href.trim() === '' || href.charAt(0) === '#') return false;
    if (link.target === '_blank' || link.hasAttribute('download')) return false;
    if (isSpecialProtocol(href) || isIgnoredElement(link)) return false;

    var url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (error) {
      return false;
    }

    if (url.origin !== window.location.origin) return false;
    if (url.href === window.location.href) return false;
    if (url.hash && url.pathname === window.location.pathname && url.search === window.location.search) return false;
    if (url.searchParams.has('section_id') || url.searchParams.has('sections')) return false;

    return true;
  }

  function showLoader() {
    loader.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('big-page-loader-active');
    document.body.classList.add('big-page-loader-active');

    requestAnimationFrame(function () {
      loader.classList.add('is-visible');
    });
  }

  function resetLoader() {
    if (navigationTimer) {
      clearTimeout(navigationTimer);
      navigationTimer = null;
    }
    loader.classList.remove('is-visible');
    loader.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('big-page-loader-active');
    document.body.classList.remove('big-page-loader-active');
  }

  function navigateAfterDelay(url) {
    navigationTimer = setTimeout(function () {
      window.location.href = url;
    }, NAV_DELAY);
  }

  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest ? event.target.closest('a[href]') : null;
    if (!shouldHandleLink(link, event)) return;

    event.preventDefault();
    showLoader();
    navigateAfterDelay(link.href);
  }, true);

  window.addEventListener('pageshow', resetLoader);
  window.addEventListener('pagehide', function () {
    if (navigationTimer) clearTimeout(navigationTimer);
  });
})();
